import { SparklesIcon } from '@quickmd-llc/design-system'

export const NEW_PATIENT_LABEL = 'First MAT home delivery order for this patient'

// Flags the patient's first non-cancelled MAT home delivery order (backend IsNewToMatHomeDelivery,
// QMD-4778). Amber (the DS warning text token) because a first fill is something the pharmacist
// should stop and look at; the label makes it readable without the hover tooltip.
export function NewPatientIcon() {
  return <SparklesIcon iconSize='s' role='img' aria-label={NEW_PATIENT_LABEL} className='text-text-warning' />
}
